<div class="query-builder-container">

  Nombre: <input size="22" bind:value={query.title}/> 

  <br>
  Consultar registros de {rid}: 
  <select 
    class="record-def-selector" 
    bind:value={rid}
    on:change={defnChanged}
    >
    <option value={-1}>el formulario ...</option>
		{#each defns as dfn}
			<option value={dfn.id}>{dfn.title}</option>
    {/each}    
  </select>

  {#if selected}
    <div>  
      <ColumnsList 
        meta={selected.meta} 
        bind:columns={query.columns}/>
    </div>
  
    <div>  
      <FiltersList 
        meta={selected.meta} 
        bind:filters={query.filters}/>
    </div>
  {/if}

</div>

<script>
  import { onMount, tick, createEventDispatcher } from 'svelte'
  import { cloned } from '@/helpers'
  import { Account, RecordDef, is } from '@/models'
  import { Query } from './query'
  import ColumnsList from './ColumnsList.svelte'
  import FiltersList from './FiltersList.svelte'
  import API from '@/api'
  import { NULLUID } from '@/models'

  export let query = null;

  const emit = createEventDispatcher();

  let 
    rid = null,
    defns = [],
    defnsSet = {},
    selected = null;

  $: if (query !== null) {
    rid = query.record_def_id;
  }

  onMount(async () => {
    // Load the RecordDefs and fill options for selector
    // let account = JSON.parse(localStorage.getItem("account"));
    let account = await Account.get()

    defns = (account.defs || []).map((t) => {
      defnsSet[""+t.id] = cloned(t)
      return { 
        id: t.id, master_id: t.master_id, 
        title: `${t.title} (v${t.version})` 
      }
    })

    rid = query.record_def_id;
    selected = (rid !== '-1') ? RecordDef.import(defnsSet[rid]) : null;

    console.log("QueryBuilder mounted rid=", rid, selected)
  })

  function defnChanged() {
    console.log("QueryBuilder defnChanged rid=", rid);

    // alert("RecordDef selected")
    selected = RecordDef.import(defnsSet[rid]);
    console.log("recordDef ", selected);
   
    // update current query 
    query.title = query.title || selected.title;
    query.master_id = selected.master_id;
    query.record_def_id = selected.id;
    query.columns = [];
    query.filters = [];
  }

</script>

<style>
  .query-builder-container {
    no-border: 1px solid #ddd;
    padding: 0;
    no-border-radius: 4px;
    no-box-shadow: 2px 2px 6px #eee;   
    no-background-color: #eee; 
  }

  .record-def-selector {
    border: none;
    background-color: transparent;
    padding: 0.25rem 0;
    color: #ab3a3a;
  }

  .query-builder-close-btn {
    background-color: #fff;
  }

</style>
